import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchAggregatePerformance, fetchDailyPerformance, fetchDailyAttributions, fetchAggregateAttributions, fetchStrategyForAdvertisable,
    STATUS_PENDING_CREATE, STATUS_CREATING, STRATEGY_ACTIVE_STATUSES, redirectToRoute, setReportingStartDate, setReportingEndDate } from '../actions.js';
import i18n from 'ar-i18n';
// import { Button } from 'react-bootstrap';
import _ from 'lodash';
import AggregatePerformanceTable from './AggregatePerformanceTable.jsx';
import DailyPerformanceTable from './DailyPerformanceTable.jsx';
import RakutenLoader from './RakutenLoader.jsx';
import Announcement from './Announcement.jsx';
import BudgetOverlay from './BudgetOverlay';
import {triggerRATPageLoadEvent} from '../utils/rat';


class Dashboard extends Component {
    static propTypes = {
        i18nLoaded: PropTypes.bool,
        dispatch: PropTypes.func,
        advertisableEid: PropTypes.string,
        strategy: PropTypes.object,
        aggregatePerformance: PropTypes.object,
        dailyPerformance: PropTypes.array,
        reportingStartDate: PropTypes.object,
        reportingEndDate: PropTypes.object,
        dailyAttributions: PropTypes.object,
        aggregateAttributions: PropTypes.object,
        recommendedBudget: PropTypes.number,
        isRecommendedBudgetDisplayed: PropTypes.bool,
        externalShopId: PropTypes.string
    };

    componentWillMount() {
        const {strategy, aggregatePerformance, dailyPerformance, dailyAttributions, aggregateAttributions, dispatch, reportingStartDate, reportingEndDate} = this.props;
        if (_.isEmpty(strategy)) {
            // dispatch(redirectToRoute(`${process.env.ROOT_PATH}`));
            return;
        }
        if (this.isCampaignPending(strategy)) {
            this.startPoll();
        }
        // Reporting start date should default to 1st of month, or campaign create date (whichever is later)
        if (!reportingStartDate) {
            const strategyStartDate = i18n.moment.utc(strategy.start_date);
            const beginOfMonth = i18n.moment.utc().startOf('month');
            let startDate = strategyStartDate.isAfter(beginOfMonth) ? strategyStartDate : beginOfMonth;
            dispatch(setReportingStartDate(startDate));
            if (startDate.isAfter(reportingEndDate)) {
                dispatch(setReportingEndDate(startDate));
            }
        }
        if (!aggregatePerformance) {
            dispatch(fetchAggregatePerformance());
        }
        if (!dailyPerformance) {
            dispatch(fetchDailyPerformance());
        }
        if (!dailyAttributions) {
            dispatch(fetchDailyAttributions());
        }
        if (!aggregateAttributions) {
            dispatch(fetchAggregateAttributions());
        }
    }

    componentDidMount() {
        const {externalShopId} = this.props;
        triggerRATPageLoadEvent('rdta_dashboard', 'rdta_dashboard', externalShopId);
    }

    componentWillReceiveProps(nextProps) {
        clearTimeout(this.timeout);
        if (this.isCampaignPending(nextProps.strategy)) {
            this.startPoll();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    render() {
        const { strategy } = this.props;
        const perf = this.props.aggregatePerformance;

        if (_.isEmpty(strategy)) {
            return (
                <Announcement />
            );
        }

        return (
            <div>
                {(strategy && strategy.ui_state && strategy.ui_state.pause_campaign_failed) ?
                    this.renderPauseCampaignErrors() : null}
                {(strategy && strategy.ui_state && strategy.ui_state.resume_campaign_failed) ?
                    this.renderResumeCampaignErrors() : null}
                {(perf && perf.ui_state && perf.ui_state.fetch_performance_failed) ?
                    this.renderReportingErrors() : null}
                { this.isReportingDataReady() ? this.renderDashboard() : this.renderLoader()}
            </div>
        );
    }

    renderLoader() {
        return (
            <div>
                <RakutenLoader className='auth-loader' />
            </div>
        );
    }

    renderPauseCampaignErrors() {
        return (
            <div className='error-message'>
                {i18n.gettext('An error occurred pausing your campaign. Please try again.')}
            </div>
        );
    }

    renderResumeCampaignErrors() {
        return (
            <div className='error-message'>
                {i18n.gettext('An error occurred resuming your campaign. Please try again.')}
            </div>
        );
    }

    renderReportingErrors() {
        return (
            <div className='error-message'>
                {i18n.gettext('An error occurred retrieving the campaign performance. Please try again.')}
            </div>
        );
    }

    renderDashboard() {
        const { strategy, isRecommendedBudgetDisplayed} = this.props;
        if (strategy.is_dirty) {
            return <RakutenLoader className='auth-loader' />;
        }
        const perf = this.props.aggregatePerformance;
        const consolidatedStatus = STRATEGY_ACTIVE_STATUSES.includes(strategy.status) ? 'Active' : 'Inactive';

        return (
            <div>
                { this.isCampaignPending(strategy) ?
                    <div className='status-message'>
                        <span>
                            {i18n.gettext('Your campaign is being launched. Please wait a few minutes.')}
                        </span>
                    </div> : null }
                <Announcement />
                <div className='section-header'>
                    { i18n.gettext('Campaign Settings') }
                </div>
                <div className='section-left-margin'>
                    <span className='campaign-setting-summary'>
                        { i18n.gettext('Daily Budget') + ': ' + i18n.numeral.formatCurrency(_.round(strategy.weekly_budget / 7.0, 0)) }
                        { isRecommendedBudgetDisplayed ? this.renderRecommendedBudget() : null }<br />
                        { strategy.monthly_budget_cap ? <span>{ i18n.gettext('Maximum Monthly Budget') }: { i18n.numeral.formatCurrency(strategy.monthly_budget_cap)}<br /></span> : null }
                        { i18n.gettext('CPC Bid') + ': ' + i18n.numeral.formatCurrency(parseFloat(strategy.kpi_goal)) } <br />
                        { i18n.gettext('Running Dates') + ': ' + i18n.moment(strategy.start_date).format('LL') + ' ~ ' }
                        { strategy.end_date ? i18n.moment(strategy.end_date).format('LL') : i18n.gettext('No end date') } <br />
                        { i18n.gettext('Status') + ': ' + i18n.gettext(consolidatedStatus) } <br />
                    </span>
                    {/* <Button
                        className='rakuten-button'
                        onClick={ this.handleEditCampaignRequest.bind(this) }
                    >
                        { i18n.gettext('Edit Campaign')}
                    </Button> */}
                </div>
                {(perf && _.isEmpty(perf.ui_state)) ? this.renderPerformance() : null}
            </div>
        );
    }


    renderPerformance() {
        return (
            <div>
                <div className='section-header'>
                    { i18n.gettext('Performance Overview') }
                </div>
                <AggregatePerformanceTable { ...this.props } />
                <div className='section-header'>
                    { i18n.gettext('Daily Performance') }
                </div>
                <DailyPerformanceTable { ...this.props } />
            </div>);
    }

    renderRecommendedBudget() {
        const { recommendedBudget } = this.props;

        return (
            <span>
                <BudgetOverlay placement='right' positionTop='425' recommendedBudget={ recommendedBudget } />
            </span>
        );
    }

    isReportingDataReady() {
        const {aggregatePerformance, dailyPerformance, dailyAttributions, aggregateAttributions} = this.props;
        return aggregatePerformance && dailyPerformance && dailyAttributions && aggregateAttributions;
    }

    isCampaignPending(strategy) {
        return strategy.status === STATUS_PENDING_CREATE || strategy.status === STATUS_CREATING;
    }

    startPoll() {
        this.timeout = setTimeout(() => this.props.dispatch(fetchStrategyForAdvertisable(this.props.advertisableEid)), 15000);
    }

    handleEditCampaignRequest() {
        this.props.dispatch(redirectToRoute(`${process.env.ROOT_PATH}campaign`));
    }

}

export default Dashboard;
